<template>
  <div>
    <Toast position="top-right" group="tr" />
    <ConfirmDialog></ConfirmDialog>
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "App",
});
</script>
